import { create } from 'zustand'
import apiHelper from '@/network/api'

interface NotificationChannel {
  id: string
  name: string
  type: string
  isActive: boolean
}

interface NotificationConfiguration {
  id: string
  interval: number
  timeConstraints: {
    schedule: {
      weekday: {
        times: string[]
      }
    }
    timezone: string
  }
}

interface KeywordNotification {
  hasSubscription: boolean
  isActive: boolean
  subscriptionId: string | null
  channels: NotificationChannel[]
  configuration: NotificationConfiguration | null
}

interface KeywordNotificationItem {
  id: string
  keyword: string
  createdAt: string
  threadsUserId: string
  notification: KeywordNotification
}

interface KeywordNotificationListState {
  keywords: KeywordNotificationItem[]
  isLoading: boolean
  error: string | null

  // Actions
  fetchKeywordNotifications: () => Promise<void>
  setKeywords: (keywords: KeywordNotificationItem[]) => void
}

const useKeywordNotificationListStore = create<KeywordNotificationListState>((set) => ({
  keywords: [],
  isLoading: false,
  error: null,

  fetchKeywordNotifications: async () => {
    try {
      set({ isLoading: true, error: null })
      const response = await apiHelper(null).get('keyword_notification/list')

      if (response.status === 200) {
        const data: KeywordNotificationItem[] = response.data
        set({
          keywords: data,
          isLoading: false
        })
      }
    } catch (error) {
      set({
        error: 'Failed to fetch keyword notifications',
        isLoading: false
      })
      console.error('Error fetching keyword notifications:', error)
    }
  },

  setKeywords: (keywords: KeywordNotificationItem[]) => set({ keywords })
}))

export default useKeywordNotificationListStore
